import { observer, inject } from "mobx-react";
import { withTranslation } from "react-i18next";

const Timer = ({ t, travelerAppStore: { secondsUntilResend: { value } } }) => {
  return `${t('sign_in.resend_in')} ${"0"}:${value}`
}

export default withTranslation()(inject("travelerAppStore")(observer(Timer)));
